const COVERALL_SIZE = ["XS / 32", "S / 36", "M / 40", "L / 44", "XL / 48", "2XL / 52", "3XL / 56"];

export default COVERALL_SIZE;
